export enum Agents {
  Brimstone,
  Viper
}
